import styled from "styled-components";
import Footer from "./Footer";

const StyledFooter = styled(Footer)`
  width: 100%;
  height: 200px;
  margin-top: 20px;
  border-top: 1px solid lightgray;
  display: flex;
  justify-content: center;
  align-items: center;

  small {
    font-size: 1.4rem;
  }
`;

export default StyledFooter;
